import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SalesReportSummaryWrapper = styled.div`
  min-width: 200px;
  padding: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background: ${Color.White};
  word-break: break-word;
`
